import { TextWithIcon, Img } from "ui-kit/components-branded/index"
import style from "modules/Booking/FormPage/components/DepositBannerNext/style.module.scss"

export function DepositBannerNext() {
    return (
        <div className={style.container}>
            <TextWithIcon icon={<Img src="calendar.png" className={style.emoji} />} position="left">
                Следующие сессии с&nbsp;этим психологом вы&nbsp;сможете забронировать в&nbsp;личном
                кабинете.
            </TextWithIcon>
        </div>
    )
}
